import { render, staticRenderFns } from "./AreaManagersPageCreate.vue?vue&type=template&id=441edb96&"
import script from "./AreaManagersPageCreate.vue?vue&type=script&lang=ts&"
export * from "./AreaManagersPageCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('441edb96')) {
      api.createRecord('441edb96', component.options)
    } else {
      api.reload('441edb96', component.options)
    }
    module.hot.accept("./AreaManagersPageCreate.vue?vue&type=template&id=441edb96&", function () {
      api.rerender('441edb96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/AreaManagers/AreaManagersPageCreate.vue"
export default component.exports